<template>
  <div class="card mgt-20px">
    <header class="header-card" >
      <p>{{ $t('addEditParution.information.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-3">
          <b-field :label="$t('addEditParution.information.code')">
            <b-input v-model="parution.code" disabled></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditParution.information.numParution')">
            <b-input v-model.number="parution.numParution" type="number"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditParution.information.nomParution')">
            <b-input v-model="parution.nomParution"></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditParution.information.dateEnvoiCF')">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="parution.dateEnvoiCF"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditParution.information.dateEnvoiBAT')">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="parution.dateEnvoiBAT"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('addEditParution.information.dateRemiseEltTech')"
            class="obligatoire">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="parution.dateRemiseEltTech"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field
            :label="$t('addEditParution.information.dateParution')"
            class="obligatoire">
            <div class="columns is-vcentered" >
              <b-datepicker
                v-model="parution.dateParution"
                class="column"
                icon="calendar-today"
                position="is-bottom-right"
                editable
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
            </div>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field :label="$t('addEditParution.information.produit')" class="obligatoire">
            <b-autocomplete
              v-model="searchRefProduit"
              :data="produits"
              field="libelleCustom"
              @select="actionSelectProduit"
              @typing="getProduits"
              :loading="isFetching" >
              <template slot="empty">
                <div v-if="!isFetching">{{$t('general.autocomplete.noRslt')}}</div>
                <div v-else>{{$t('general.autocomplete.search')}}</div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { SENS_VENTE } from '@/configuration/devisConf';
import { getAll } from '@/api/produit/produitPresse';
import { createNamespacedHelpers } from 'vuex';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    parution: {
      type: Object,
      required: true,
    },
    produit: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isFetching: false,
      produits: [],
      searchRefProduit: '',
    };
  },
  methods: {
    actionSelectProduit(option) {
      this.parution.produitId = option.id;
      if (this.parution.id) {
        this.parution.produit = {
          id: option.id,
          reference: option.reference,
          libelle: option.libelle,
        };
      }
      this.$emit('setProduit', option);
    },
    getProduits: debounce(async function produits() {
      this.produits = [];
      if (!this.searchRefProduit) return;
      const societeId = this.parution.societeId || this.societeActiveId;
      this.isFetching = true;
      this.parution.produitId = null;
      const query = {
        query: {
          societeId,
          sens: SENS_VENTE,
          actif: true,
          auto: this.searchRefProduit,
        },
      };
      const produits = (await getAll(query)).data.result.items;

      produits.forEach((produitPresse) => {
        produitPresse.libelleCustom = produitPresse.reference + ' - ' + produitPresse.libelle;
      });

      this.produits = produits;
      this.isFetching = false;
    }, 500),
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    if (this.produit) {
      this.searchRefProduit = this.produit.reference + ' - ' + this.produit.libelle;
      this.parution.produitId = this.produit.id;
    }
  },
};
</script>
